{
	"title": "Bout",
	"waitingBoth": "Waiting for both corners to be decided",
	"needsTwo": {
		"title": "A bout needs two corners",
		"body_one": "This meet has {{count}} slot. Set exactly two in the start list.",
		"body_other": "This meet has {{count}} slots. Set exactly two in the start list."
	},
	"corner": {
		"RED": "Red",
		"BLUE": "Blue",
		"WHITE": "White",
		"AKA": "Aka",
		"AO": "Ao",
		"other": "Corner {{side}}",
		"numbered": "Corner {{n}}"
	},
	"columns": {
		"corner": "Corner",
		"penaltyTotal": "{{penalty}} total"
	},
	"round": {
		"label": "Round {{n}}",
		"short": "R{{n}}",
		"score": "Score",
		"won": "Round won",
		"winner": "Won",
		"method": "Decision",
		"methodNone": "By score",
		"member": "Fencer",
		"memberNone": "Not set",
		"leg": "Leg {{n}}",
		"legTouches": "Touches this leg",
		"running": "Running {{score}}",
		"runningHint": "The team's running score after this leg, as the scoresheet shows it."
	},
	"decideBy": {
		"ROUNDS": "Rounds won",
		"TOTAL": "Points",
		"JUDGES": "Judges' votes",
		"TALLIES": "Score"
	},
	"verdict": {
		"needsRounds_one": "No winner yet. The first corner to win {{count}} round wins.",
		"needsRounds_other": "No winner yet. The first corner to win {{count}} rounds wins.",
		"needsAllRounds": "No winner yet. Enter every round for both corners.",
		"needsCards": "No winner yet. Every judge's card needs all rounds.",
		"doubleIrm": "Both corners have a mark. The referee decides the result.",
		"bothMethods": "A win method is recorded for both corners. Choose the winner's corner.",
		"byIrm": "{{corner}} wins: {{irm}} for {{loser}}",
		"byMethod": "{{corner}} wins ({{method}})",
		"byScore": {
			"ROUNDS": "{{corner}} wins on rounds, {{score}}",
			"TOTAL": "{{corner}} wins on points, {{score}}",
			"JUDGES": "{{corner}} wins on judges' cards, {{score}}",
			"TALLIES": "{{corner}} wins on the score, {{score}}"
		},
		"conflict": "The score says {{corner}} wins, but the win method is recorded for {{other}}. Move it if that was a slip. Keep it if the referee stopped the bout.",
		"moveMethod": "Move win method to {{corner}}",
		"needsTarget": "No winner yet. The first corner to {{count}} wins, else the higher score once every period is entered.",
		"hansokuMake": "{{corner}} has {{count}} shido. Three shido is hansoku-make: record it as the win method for {{other}} if the referee gave it.",
		"goldenScore": "No winner yet. The score is level: golden score, the first score wins.",
		"needsPriority": "Level at time. Priority decides: record PRI as the win method for the corner that won it.",
		"relayOverrun_one": "Leg {{legs}}: a team's running score is past 5 touches per leg. Enter the touches scored in each leg, not the scoresheet's running total.",
		"relayOverrun_other": "Legs {{legs}}: a team's running score is past 5 touches per leg. Enter the touches scored in each leg, not the scoresheet's running total.",
		"roundConflict": "Round {{n}}: {{method}} is recorded for {{corner}}, but {{other}} has the higher score, so the score stands. Move it if that was a slip."
	},
	"method": {
		"label": "Win method",
		"none": "Not recorded",
		"option": "{{name}} ({{code}})",
		"for": "Winner's corner",
		"pickCorner": "Choose the winner's corner to record the win method."
	},
	"fills": {
		"WINNER": "Winner goes on to {{meet}}, in the {{corner}} corner there",
		"LOSER": "Loser goes on to {{meet}}, in the {{corner}} corner there"
	},
	"tallies": "Scoring breakdown",
	"judges": {
		"title_one": "Judges' cards ({{count}} judge)",
		"title_other": "Judges' cards ({{count}} judges)",
		"recordOnly": "Recorded only. This sport is decided by the score.",
		"noCards": "No cards entered.",
		"seat": "Judge",
		"total": "Total",
		"vote": "Card for",
		"level": "Level",
		"earlierRound": "Score the earlier round first"
	},
	"format": {
		"label": "Format",
		"bestOf_one": "Best of {{count}} round",
		"bestOf_other": "Best of {{count}} rounds",
		"bestOfLength_one": "Best of {{count}} round of {{time}}",
		"bestOfLength_other": "Best of {{count}} rounds of {{time}}",
		"roundsOf_one": "{{count}} round of {{time}}",
		"roundsOf_other": "{{count}} rounds of {{time}}",
		"rounds_one": "{{count}} round",
		"rounds_other": "{{count}} rounds",
		"default": "Sport default, not set for this meet",
		"set": "Set format",
		"change": "Change format",
		"lockedResults": "The format can't be changed once the bout has results.",
		"roundsLabel": "Rounds",
		"lengthLabel": "Round length (m:ss)",
		"save": "Save format",
		"roundsInvalid": "Rounds must be a whole number from 1 to 12.",
		"lengthInvalid": "Round length must be a time such as 2:00.",
		"stale": "Someone else changed this meet. It has been reloaded. Try again.",
		"played": "Played: {{list}}",
		"playedRound": "round {{n}} {{time}}",
		"targetOf": "to {{count}}",
		"targetLabel": "Bout ends at",
		"targetInvalid": "The score that ends the bout must be a whole number from 1 to {{max}}."
	},
	"note": {
		"penalties": "Enter each round's score as the scoreboard shows it, including points given for the opponent's {{penalty}}. {{penalty}} are counted on the corner that committed them and are never subtracted."
	},
	"aria": {
		"cornerScore": "{{corner}}: {{score}}",
		"roundScore": "Round {{n}} score, {{corner}}",
		"roundPenalty": "Round {{n}} {{penalty}}, {{corner}}",
		"tally": "{{tally}}, {{corner}}",
		"judgeScore": "Judge {{seat}}, round {{n}}, {{corner}}",
		"roundMethod": "Round {{n}} decision, {{corner}}",
		"legTouches": "Leg {{n}} touches, {{corner}}",
		"legMember": "Leg {{n}} fencer, {{corner}}"
	},
	"settings": {
		"button": "Settings"
	},
	"tsr": {
		"title": "TSR live",
		"none": "TSR has no live score for this bout.",
		"readError": "No answer from TSR. Retrying.",
		"unreadable": "TSR sent a bout OVR cannot read.",
		"phase": {
			"pre": "Not started",
			"round": "Round {{n}} of {{rounds}}",
			"rest": "Break after round {{n}}",
			"decision": "Waiting for the decision",
			"final": "Bout over"
		},
		"judgesAhead": "Judges ahead",
		"judgesAheadTitle": "Judges ahead over the rounds every judge has scored",
		"roundsScored": "Rounds scored: {{n}} of {{rounds}}",
		"keying": "Round {{n}} cards: {{entered}} of {{judges}} in",
		"calls": "Warnings {{red}} {{warningsR}}, {{blue}} {{warningsB}} · Counts {{red}} {{countsR}}, {{blue}} {{countsB}}",
		"decision": "Decision: {{corner}} by {{method}}",
		"decisionRound": "Decision: {{corner}} by {{method}}, round {{round}}",
		"againstCards": "The decision names the corner the cards do not.",
		"apply": "Apply TSR score",
		"applyReadOnly": "This bout cannot be edited now.",
		"applied": "TSR score put on the board and saving.",
		"auto": {
			"label": "Auto-apply",
			"hint": "On this computer: save TSR's cards, calls and decision by themselves after every complete round.",
			"on": "Auto-apply is on: TSR's cards are saved after every complete round, with the calls and the decision.",
			"waiting": "Auto-apply is waiting: save or discard the edits on the board first.",
			"readOnly": "Auto-apply is on, but this bout cannot be edited now.",
			"applied": "TSR score saved automatically.",
			"appliedFinal": "Bout over: TSR's final result saved automatically."
		},
		"refused": {
			"no-slots": "Both corners need a boxer before the score can be applied.",
			"nothing-to-apply": "TSR has no complete round or decision for this bout yet."
		}
	}
}
